export default function ReviewSection() {
  const ratings = [
    { category: "Product Variety", score: 4.7 },
    { category: "Shipping Service", score: 4.3 },
    { category: "Warehouse Service", score: 4.5 },
    { category: "Customer Support", score: 4.1 },
    { category: "Beginner Experience", score: 4.2 },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Honest Review
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Sugargoo Review <span className="text-primary-500">2026</span>
          </h2>
          <p className="text-foreground-600 max-w-3xl mx-auto leading-relaxed">
            After extensive testing and hundreds of successful orders, here is our comprehensive review of Sugargoo's platform. We evaluate every aspect — from product discovery and seller communication to warehouse handling and international delivery.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="rounded-lg border border-background-200/70 overflow-hidden">
              {ratings.map((item, i) => (
                <div
                  key={item.category}
                  className={`flex items-center justify-between px-5 py-3.5 ${
                    i !== 0 ? "border-t border-background-200/40" : ""
                  }`}
                >
                  <span className="text-sm font-medium text-foreground-700">
                    {item.category}
                  </span>
                  <div className="flex items-center gap-3">
                    <div className="w-32 h-2 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-accent-500"
                        style={{ width: `${(item.score / 5) * 100}%` }}
                      ></div>
                    </div>
                    <span className="text-sm font-semibold text-accent-700 w-8 text-right">
                      {item.score}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col justify-center">
            <div className="bg-background-50 rounded-lg border border-background-200/70 p-6">
              <div className="flex items-center gap-2 mb-3">
                <span className="text-3xl font-bold text-primary-500">4.4</span>
                <span className="text-foreground-600 text-sm">/ 5.0 Overall Rating</span>
              </div>
              <div className="flex gap-0.5 mb-4">
                {[1, 2, 3, 4].map((s) => (
                  <i key={s} className="ri-star-fill text-accent-500 text-lg"></i>
                ))}
                <i className="ri-star-half-line text-accent-500 text-lg"></i>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                Sugargoo is a legitimate and reliable shopping agent with an extensive product catalog, competitive shipping rates, and a user-friendly platform. While there is a learning curve for complete beginners, the spreadsheet resources and QC system make it one of the best options available for international buyers in 2026.
              </p>
              <div className="flex flex-wrap gap-2">
                {["Reliable", "Affordable", "Trusted", "Easy to Use"].map((tag) => (
                  <span
                    key={tag}
                    className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}